interface StepLike {
	stepType?: string
	slice?: {
		content?: Array<{ type?: string; text?: string }>
	}
}

interface TransactionLike {
	steps: unknown[]
}

const TYPED_TEXT_LIMIT = 3

function isPlainTextStep(step: StepLike): boolean {
	if (step.stepType !== "replace") return false
	const content = step.slice?.content
	if (!content || content.length === 0) return true
	if (content.length > 1) return false
	const [node] = content
	if (node?.type !== "text") return false
	return (node.text?.length ?? 0) <= TYPED_TEXT_LIMIT
}

/**
 * True when a change came from a command rather than typing: a link, a mark, an
 * image, a paste. Those land in one transaction, so the debounce that hides a
 * keystroke swallows the whole edit if the tab closes first.
 */
export function isDiscreteEditorChange(
	transaction: TransactionLike | null | undefined,
): boolean {
	const steps = transaction?.steps
	if (!steps || steps.length === 0) return false

	return steps.some((rawStep) => {
		const step =
			typeof (rawStep as { toJSON?: () => unknown }).toJSON === "function"
				? ((rawStep as { toJSON: () => unknown }).toJSON() as StepLike)
				: (rawStep as StepLike)

		return !isPlainTextStep(step)
	})
}
